"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getInputBorderWidth = function getInputBorderWidth(_ref) {
  var theme = _ref.theme,
    withSuffix = _ref.withSuffix,
    withPrefix = _ref.withPrefix,
    focused = _ref.focused,
    isReadOnly = _ref.isReadOnly;
  var borderTop;
  var borderRight;
  var borderBottom;
  var borderLeft;
  var borderProp = isReadOnly && !focused ? 'borderWidthReadOnly' : 'borderWidth';
  var borderValues = borderProp && theme[borderProp] ? theme[borderProp].split(' ') : '';
  if (!theme[borderProp] || !borderValues) {
    console.error("".concat(borderProp, " was not defined")); // eslint-disable-line

    return 'none';
  }
  switch (borderValues.length) {
    case 4:
      var _borderValues = _slicedToArray(borderValues, 4);
      borderTop = _borderValues[0];
      borderRight = _borderValues[1];
      borderBottom = _borderValues[2];
      borderLeft = _borderValues[3];
      break;
    case 3:
      var _borderValues2 = _slicedToArray(borderValues, 3);
      borderTop = _borderValues2[0];
      borderLeft = _borderValues2[1];
      borderBottom = _borderValues2[2];
      borderRight = borderLeft;
      break;
    case 2:
      var _borderValues3 = _slicedToArray(borderValues, 2);
      borderTop = _borderValues3[0];
      borderLeft = _borderValues3[1];
      borderBottom = borderTop;
      borderRight = borderLeft;
      break;
    case 1:
    default:
      var _borderValues4 = _slicedToArray(borderValues, 1);
      borderTop = _borderValues4[0];
      borderBottom = borderTop;
      borderLeft = borderTop;
      borderRight = borderTop;
  }
  if (withPrefix && !theme.prefixSuffixInsideInput) {
    return "".concat(borderTop, " ").concat(borderRight, " ").concat(borderBottom, " 0");
  }
  if (withSuffix && !theme.prefixSuffixInsideInput) {
    return "".concat(borderTop, " 0 ").concat(borderBottom, " ").concat(borderLeft);
  }
  return "".concat(borderTop, " ").concat(borderRight, " ").concat(borderBottom, " ").concat(borderLeft);
};
var _default = getInputBorderWidth;
exports["default"] = _default;